import { useCallback, useState } from 'react';

/**
 * Boolean UI preference persisted in localStorage ('true' | 'false').
 * Storage failures (private mode, blocked) fall back to in-memory state.
 * @param {string} key
 * @param {boolean} [initial=false]
 * @returns {[boolean, () => void]} value and toggle
 */
export function usePersistedFlag(key, initial = false) {
  const [value, setValue] = useState(() => {
    try {
      const v = localStorage.getItem(key);
      return v === null ? initial : v === 'true';
    } catch { return initial; }
  });
  const toggle = useCallback(() => {
    setValue((v) => {
      const next = !v;
      try { localStorage.setItem(key, String(next)); } catch { /* ignore */ }
      return next;
    });
  }, [key]);
  return [value, toggle];
}
